// 2) Third-party library imports
import {
    createAction,
    createSlice,
    PayloadAction
} from '@reduxjs/toolkit';

// 3c) Project-specific modules - components / types
import {
    CompanyInviteCreatePayload,
    CompanyInviteCreateResponse,
    CompanyInviteLinkResponse,
    CompanyInviteValidateResponse,
    InvitesState
} from './types';
import type { RootState } from '../storeTypes';

const actionPrefix = 'invite';

// Type-safe initialState!
export const initialState: InvitesState = {
    companyInviteLinkingInProgress: false,
};

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const inviteSlice = createSlice({
    name: actionPrefix,
    initialState,
    reducers: {
        companyInviteLinkingInProgressUpdateAction: {
            reducer: (
                state,
                action: PayloadAction<{ inProgress: boolean }>
            ) => {
                state.companyInviteLinkingInProgress = action.payload.inProgress;
            },
            prepare: (inProgress: boolean) => ({
                payload: {
                    inProgress,
                }
            })
        }
    }
});

const { actions, reducer } = inviteSlice;

// Actions
export const {
    companyInviteLinkingInProgressUpdateAction,
} = actions;

export const companyInviteCreateAction = createAction(
    `${actionPrefix}/companyInviteCreateAction`,
    function prepare(
        payload: CompanyInviteCreatePayload,
        callback?: (response: CompanyInviteCreateResponse) => void,
    ) {
        return {
            payload: {
                payload,
                callback,
            }
        };
    }
);

export const companyInviteValidateAction = createAction(
    `${actionPrefix}/companyInviteValidateAction`,
    function prepare(
        inviteToken: string,
        callback?: (response: CompanyInviteValidateResponse) => void,
    ) {
        return {
            payload: {
                inviteToken,
                callback,
            }
        };
    }
);

export const companyInviteLinkAction = createAction(
    `${actionPrefix}/companyInviteLinkAction`,
    function prepare(
        inviteToken: string,
        callback?: (response: CompanyInviteLinkResponse) => void,
    ) {
        return {
            payload: {
                inviteToken,
                callback,
            }
        };
    }
);

// Selectors
export const getInvitesState = (state: RootState) => state.invites;
export const getCompanyInviteLinkingInProgress = (state: RootState) => state.invites.companyInviteLinkingInProgress;
// Reducer
export default reducer;
